import React from 'react';
import * as HeroIcons from '@heroicons/react/24/outline';

interface AchievementBadgeProps {
  id: string;
  title: string;
  description: string;
  icon: string;
  earned: boolean;
  earnedDate?: string;
}

export default function AchievementBadge({
  title,
  description,
  icon,
  earned,
  earnedDate
}: AchievementBadgeProps) {
  const IconComponent = (HeroIcons as any)[icon];

  return (
    <div 
      className={`relative p-4 rounded-lg border transition-all duration-300 ${
        earned 
          ? 'bg-white border-blue-200 shadow-sm hover:shadow-md' 
          : 'bg-gray-50 border-gray-200 opacity-60'
      }`}
    >
      {/* Icon */}
      <div className={`flex justify-center mb-3 ${earned ? 'text-blue-600' : 'text-gray-400'}`}>
        {IconComponent && <IconComponent className="w-8 h-8" />}
      </div>

      {/* Title */}
      <h4 className={`text-sm font-semibold text-center mb-1 ${earned ? 'text-gray-900' : 'text-gray-500'}`}>
        {title}
      </h4>

      {/* Description */}
      <p className={`text-xs text-center ${earned ? 'text-gray-600' : 'text-gray-400'}`}>
        {description}
      </p>

      {/* Earned Date */}
      {earned && earnedDate && (
        <p className="text-xs text-center text-gray-500 mt-2 pt-2 border-t border-gray-200">
          {earnedDate}
        </p>
      )}

      {/* Lock Indicator for Unearned */}
      {!earned && (
        <div className="absolute top-2 right-2 bg-white rounded-full p-1 border border-gray-200">
          <HeroIcons.LockClosedIcon className="w-3 h-3 text-gray-400" />
        </div>
      )}
    </div>
  );
}